import { forwardRef } from 'react'
import { useTranslation } from '@front/model'
import { createPolymorphicComponent } from '@mantine/core'
import { TButton, type TButtonProps } from './button'

export type ButtonEditProps = Omit<TButtonProps, 'leftSection' | 'icon'>

const _ButtonEdit = forwardRef<HTMLButtonElement, ButtonEditProps>(({ children, ...props }, ref) => {
  const { t } = useTranslation()
  return (
    <TButton icon='edit' variant={props.variant} {...props} ref={ref}>
      {children || t('Edit')}
    </TButton>
  )
})

_ButtonEdit.displayName = 'ButtonEdit'

export const ButtonEdit = createPolymorphicComponent<'button', ButtonEditProps>(_ButtonEdit)
